import { render, staticRenderFns } from "./TagsSelectBox.vue?vue&type=template&id=052ec638&scoped=true&"
import script from "./TagsSelectBox.vue?vue&type=script&lang=js&"
export * from "./TagsSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./TagsSelectBox.vue?vue&type=style&index=0&id=052ec638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ec638",
  null
  
)

export default component.exports